import React, { useEffect } from "react";
import { Total } from "../../../Components/Total";
import { Stack } from "@mui/material";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { Card } from "./Components/Card";
import { CardSkeleton } from "./Components/CardSkeleton";
import DrawerAppBar from "../../../../../components/mobile/Navbar";
import { useAuditContext } from "../../store";
import { LoadProductListByManyCodes } from "../../../../../../domain/usecases/load-product-list-by-many-codes";
import { ItemCount } from "../../../../../../domain/usecases/audit-position";

type Props = {
  loadProductListByManyCodes: LoadProductListByManyCodes;
};

export const AuditReport: React.FC<Props> = ({
  loadProductListByManyCodes,
}) => {
  const navigate = useNavigate();

  const { result, setResult } = useAuditContext();

  const items = result?.error?.data.items as ItemCount;

  useEffect(() => {
    async function getProductDescription() {
      if (!result) return;
      if (!items) return;
      try {
        const codes = items.map((item: any) => item.code);
        const products = await loadProductListByManyCodes.load(codes);
        items.forEach((item) => {
          const match = products.find(
            (product) => product.eanCode === item.code
          );
          if (match) {
            item.description = match.description;
            item.reference = match.reference;
          }
        });
        setResult({
          status: result.status,
          error: {
            type: result?.error?.type || "Critical Error",
            data: { items },
          },
        });
      } catch (error) {}
    }

    getProductDescription();
  }, []);

  return (
    <>
      <DrawerAppBar
        title="Relatório"
        onBack={() => {
          navigate(-1);
        }}
      />
      <Total
        text="Total de Produtos"
        number={items ? `${items?.length}` : "0"}
      />
      <Stack sx={{ m: "20px" }} spacing={4}>
        <>
          {items ? (
            <>
              {items.map((item: any, index: number) => {
                const success = item.amount === 0;
                return (
                  <Card
                    key={index}
                    title={success ? "Suceso" : "Quantidade Incorreta"}
                    content={
                      success
                        ? `O produto ${item.description}${
                            item.batch && ", Lote " + item.batch
                          } está correto `
                        : `O produto de código ${item.code} está incorreto`
                    }
                    success={success}
                  />
                );
              })}
              <Button
                variant="contained"
                color="secondary"
                sx={{ color: "white", height: "50px", fontWeight: "bold" }}
                onClick={() => {
                  navigate("/mobile/tasks");
                }}
              >
                Sair
              </Button>
            </>
          ) : (
            <>
              <CardSkeleton />
              <CardSkeleton />
              <CardSkeleton />
            </>
          )}
        </>
      </Stack>
    </>
  );
};
